import { combineReducers } from 'redux';

import {
  ACTION_LOAD_FAVICON__SUCCESS,
  ACTION_UPLOAD_FAVICON__SUCCESS,
  ACTION_DELETE_FAVICON__SUCCESS,
  ACTION_DELETE_FAVICON__REQUEST,
  ACTION_DELETE_FAVICON__FAIL,
} from '../actionTypes';

import errors from './errors';


const data = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_FAVICON__SUCCESS:
    case ACTION_UPLOAD_FAVICON__SUCCESS:
      return action.payload.favicon;

    case ACTION_DELETE_FAVICON__SUCCESS:
      return {};

    default:
      return state;
  }
};

const isFaviconBeingDeleted = (state = false, action) => {
  switch (action.type) {
    case ACTION_DELETE_FAVICON__REQUEST:
      return true;

    case ACTION_DELETE_FAVICON__SUCCESS:
    case ACTION_DELETE_FAVICON__FAIL:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  errors,
  data,
  isFaviconBeingDeleted,
});
